import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'
import ru from './ru'
import { getI18nLocale, DEFAULT_LANG } from './config'

Vue.use(VueI18n)

const messages = {
  zh: {
    ...zh,
  },
  en: {
    ...en,
  },
  ru: {
    ...ru,
  }
}

const savedLang = localStorage.getItem('language') || DEFAULT_LANG

const i18n = new VueI18n({
  locale: getI18nLocale(savedLang),
  fallbackLocale: 'zh',
  messages
})

export default i18n
